<script setup>
import AppSnackbar from '@/components/AppSnackbar.vue'
import ConfirmDialog from '@/components/modalComponent.vue'
import { useAppTheme } from '@/composables/useAppTheme'
import { provide, ref } from 'vue'

const { loadTheme } = useAppTheme()
const confirmDialog = ref(null)
const snackbarRef = ref(null)

loadTheme()

// ✅ Snackbar global
provide('snackbar', {
  open: (message, type = 'success') => {
    snackbarRef.value?.open(message, type)
  },
})

// ✅ Confirm dialog global
provide('confirm', options => {
  return confirmDialog.value.open(options)
})

const cached = localStorage.getItem('appTheme')
if (cached) {
  const { applyTheme } = useAppTheme()

  applyTheme(JSON.parse(cached))
}
</script>

<template>
  <VApp>
    <RouterView />

    <!-- Global components -->
    <ConfirmDialog ref="confirmDialog" />
    <AppSnackbar ref="snackbarRef" />
  </VApp>
</template>
